export function isExternalUrl(uri) {
  return /^(https?|\/\/).+$/i.test(uri);
}

export function isLocalProtocol(uri) {
  return /^(\w+:[^//]).+$/i.test(uri);
}
